<template>
    <div>
        <DxDropDownBox
            ref="dropDownBoxRefName"
            :drop-down-options="dropDownOptions"
            :data-source="dataSource"
            :value.sync="currentValue"
            :show-clear-button="true"
            @value-changed="onValueChangedDropBox"
            @opened='onOpened'
            display-expr="부서명"
            value-expr="부서코드"
            content-template="contentTemplate"
        >
            <template #contentTemplate="{}">
                <DxTreeView ref='refDivision'
                  :items="getDtaSource"
                  :width="300"
                  :height='300'
                  :expandAllEnabled="true"
                  :expandNodesRecursive='true'
                  data-structure="plain"
                  parent-id-expr="상위부서코드"
                  key-expr="부서코드"
                  display-expr="부서명"
                  @item-click="selectItem"
                />
            </template>
        </DxDropDownBox>
    </div>
</template>

<script>
import DxTreeView from 'devextreme-vue/tree-view'
import DxDropDownBox from 'devextreme-vue/drop-down-box'
export default {
  name: 'divisionTree',
  data: function () {
    return {
      currentValue: this.value,
      dropDownOptions: { width: 300 }
    }
  },
  props: {
    value: {
      type: String,
      default: null
    },
    onValueChanged: {
      type: Function,
      default: () => function () {}
    },
    dataSource: {
      type: Array,
      default: () => {}
    }
  },
  components: {
    DxTreeView,
    DxDropDownBox
  },
  computed: {
    getDtaSource () {
      return this.dataSource
    }
  },
  created () {
    // this.refreshDivision()
  },
  mounted () {
  },
  methods: {
    onOpened () {
      this.$refs.refDivision.instance.expandAll()
    },
    onValueChangedDropBox (e) {
      // // console.log(e)
      if (e.value === null) {
        this.currentValue = e.value
        this.onValueChanged(this.currentValue)
      }
    },
    refreshDivision () {
      this.$_sp.runNoEncodeFindSqlProc('부서정보', null)
        .then((data) => {
          this.divisionList = this.$_sp.MakeModel(data)
          // // console.log(this.divisionList)
        })
    },
    selectItem (e) {
      // // console.log(e.itemData.부서명)
      this.currentValue = e.itemData.부서코드
      this.onValueChanged(e.itemData.부서코드)
      this.$refs.dropDownBoxRefName.instance.close()
    }
  }
}
</script>

<style lang="scss">

</style>
